import { API_BASE_URL } from '../hooks/axios';

export function vehicleImageUrl(imageName?: string | null): string | null {
  if (!imageName?.trim()) {
    return null;
  }
  return `${API_BASE_URL}/uploads/vehicles/${encodeURIComponent(imageName.trim())}`;
}
